import request from '../request'

// 获取列表
export function getList(params = {}) {
    return request({
        url: '/information/Xzqh/selectList',
        method: 'GET',
        params
    })
}

// 修改
export function updateCultrueName(data = {}) {
    return request({
        method: 'POST',
        url: '/verify/Xzqu/update',
        data,
        type: 'img'
    })
}
// 添加
export function addCultrueName(data = {}) {
    return request({
        url: '/verify/Xzqu/add',
        method: 'POST',
        data,
        type: 'img'
    })
}
// 删除
export function deleteCultrueName(params = {}) {
    return request({
        url: '/verify/Xzqh/del',
        method: 'Delete',
        params
    })
}

// 上传图片
export function uploadImg(data){
    return request({
        url:'verify/news/detail/picture/one',
        method:'POST',
        data
    })
}

